import { TFunction } from '@getpopsure/i18n-react';
import { email } from '@getpopsure/private-constants';
import { Address } from '@getpopsure/public-models';
import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { mergePolicyAttr } from 'actions/policies';
import { useDispatch } from 'react-redux';
import endpoint from 'shared/api';

export const useUpdatePolicyAddress = (t: TFunction) => {
  const dispatch = useDispatch();
  const updatePolicyAddressFn = ({
    policyId,
    address,
  }: {
    policyId: string;
    address: Address;
  }) => endpoint.updatePolicyAddress(policyId, address);

  const {
    mutate: updateAddress,
    isLoading,
    isError,
    isSuccess,
  } = useMutation({
    mutationFn: updatePolicyAddressFn,
    onError: (error, variables) => {
      Sentry.captureException(error, {
        tags: {
          feature: 'POLICY_SINGLE',
        },
        extra: {
          policyId: variables.policyId,
          description: 'Policy address update request failed',
        },
      });
    },
    onSuccess: (_, variables) => {
      dispatch(
        mergePolicyAttr(variables.policyId, {
          address: variables.address,
        })
      );
    },
  });

  const error = isError
    ? t(
        'myPolicies.updateAddress.errorMessage',
        "We couldn't update your address. Please try again in a few minutes, if the problem persists contact us at {{supportEmail}}",
        { supportEmail: email.help }
      )
    : undefined;

  return {
    updateAddress,
    isLoading,
    error,
    isSuccess,
  };
};
